import styled from 'styled-components';
import media from '../../constants/media';
import { Column } from '../base/grid';
import DynamicRspImage from '../base/images/dynamicRspImageBg';

export const Wrapper = styled.div``;

export const FormWrapper = styled.div`
	iframe {
		width: 100%;
		min-height: 30rem;
	}
`;

export const FormImage = styled(DynamicRspImage)`
	padding-top: 40%;
	height: 100%;
`;

export const ImageColumn = styled(Column)`
	${media.mobileAndTabletOnly`
		display: none;
	`};

	${media.desktopSmallOnly`
		display: none;
	`};
`;
